const initialState = {
  Companies: [],
  selectedCompany: null,
  currentTab: 0,
  usedSapCodes: [],
};

const AddressReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case 'SET_COMPANIES': {
      return { ...state, Companies: action.data };
    }
    case 'SELCTED_COMPANY': {
      const selectedCompany = {
        company_id: action.data.company_id,
        company_name: action.data.company_name
      };
      
      // Find the tab index for the selected company
      const tabIndex = state.Companies.findIndex(
        company => company.company_id === action.data.company_id
      );
      
      return { 
        ...state, 
        selectedCompany: selectedCompany,
        currentTab: tabIndex >= 0 ? tabIndex : 0
      };
    }
    case 'SET_CURRENT_TAB': {
      const requestedTab = Number(action.data);
      const maxIndex = state.Companies.length - 1;
      const safeTab = Number.isNaN(requestedTab)
        ? 0
        : Math.min(Math.max(requestedTab, 0), Math.max(maxIndex, 0));

      return {
        ...state,
        currentTab: safeTab,
      };
    }
    case 'SET_USED_SAP_CODES': {
      return { ...state, usedSapCodes: action.data };
    }
    default:
      return state;
  }
};
export default AddressReducer;